export default "__VITE_ASSET__fef3tXuE__"